module.exports = __webpack_public_path__ + "assets/img/images-links-1.55a527da.jpg";